import React from 'react';
import './blockchain-transaction-info.scss';
import { IconBtn } from '@ru-digital-assets/ui-component';
import { CopyIcon } from 'assets/icons';

interface IBlockchainTransactionInfo {
  hash: string;
}

export default function BlockchainTransactionInfo({
  hash,
}: IBlockchainTransactionInfo) {
  return (
    <div>
      <div className="flex align-center mb_12">
        <p className="p mr_10">{hash.slice(0, 20) + '..' + hash.slice(-15)}</p>
        <CopyIcon
          className="cursor-pointer"
          width={20}
          height={20}
          onClick={() => {
            navigator.clipboard.writeText(hash);
          }}
        />
      </div>
      <IconBtn
        title="Проверить транзакцию в блокчейн Explorer"
        sm
        outlined
        onClick={() => {
          window!.open(`https://explorer.cfa.digital/tx/${hash}`, '_blank')!.focus();
        }}
      />
    </div>
  );
}
